/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_WritingInputs */

const en_import_status_writing = /** @type {(inputs: Import_Status_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing recipe…`)
};

const de_import_status_writing = /** @type {(inputs: Import_Status_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept wird geschrieben…`)
};

/**
* | output |
* | --- |
* | "Writing recipe…" |
*
* @param {Import_Status_WritingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_writing = /** @type {((inputs?: Import_Status_WritingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_WritingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_writing(inputs)
	return en_import_status_writing(inputs)
});